/**
 * @generated SignedSource<<88204bf9d578a80a07d9be34ad756dbd>>
 * @relayHash f537495882fb8cedf69b66475b58f348
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f537495882fb8cedf69b66475b58f348

import { ConcreteRequest } from 'relay-runtime';
export type DoctorNetworkRole = "FAMILY_DOCTOR" | "GATEKEEPER" | "SPECIALIST";
export type careProviderSearchDoctorNetworksQuery$variables = {
  patientId: string;
};
export type careProviderSearchDoctorNetworksQuery$data = {
  readonly ch_patientById: {
    readonly doctorNetworks: ReadonlyArray<{
      readonly careProvider: {
        readonly businessName: string | null;
        readonly city: string | null;
        readonly creditorCodeRegister: string | null;
        readonly firstName: string | null;
        readonly id: string;
        readonly lastName: string | null;
        readonly postalCode: string | null;
        readonly streetAddress: string | null;
        readonly title: string | null;
      };
      readonly id: string;
      readonly role: DoctorNetworkRole;
    }>;
  } | null;
};
export type careProviderSearchDoctorNetworksQuery = {
  response: careProviderSearchDoctorNetworksQuery$data;
  variables: careProviderSearchDoctorNetworksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "patientId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "DoctorNetwork",
  "kind": "LinkedField",
  "name": "doctorNetworks",
  "plural": true,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CareProvider",
      "kind": "LinkedField",
      "name": "careProvider",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "businessName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creditorCodeRegister",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postalCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streetAddress",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "careProviderSearchDoctorNetworksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "careProviderSearchDoctorNetworksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ch_Patient",
        "kind": "LinkedField",
        "name": "ch_patientById",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f537495882fb8cedf69b66475b58f348",
    "metadata": {},
    "name": "careProviderSearchDoctorNetworksQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "59626d3afb981f9b37dc16a9bde0a545";

export default node;
